var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96971 3.29289C7.15725 3.10536 7.4116 3 7.67682 3H21.6768C21.942 3 22.1964 3.10536 22.3839 3.29289C22.5715 3.48043 22.6768 3.73478 22.6768 4V14C22.6768 14.2652 22.5715 14.5196 22.3839 14.7071C22.1964 14.8946 21.942 15 21.6768 15H19.6768V17H21.6768C22.4725 17 23.2355 16.6839 23.7981 16.1213C24.3607 15.5587 24.6768 14.7957 24.6768 14V4C24.6768 3.20435 24.3607 2.44129 23.7981 1.87868C23.2355 1.31607 22.4725 1 21.6768 1H7.67682C6.88117 1 6.11811 1.31607 5.5555 1.87868C4.99289 2.44129 4.67682 3.20435 4.67682 4V6H6.67682V4C6.67682 3.73478 6.78218 3.48043 6.96971 3.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6768 18C19.6768 18.5304 19.4661 19.0391 19.091 19.4142C18.716 19.7893 18.2073 20 17.6768 20H5.67682L1.67682 24V8C1.67682 7.46957 1.88753 6.96086 2.26261 6.58579C2.63768 6.21071 3.14639 6 3.67682 6H17.6768C18.2073 6 18.716 6.21071 19.091 6.58579C19.4661 6.96086 19.6768 7.46957 19.6768 8V18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedChatIcon);
export default __webpack_public_path__ + "static/media/openedChat_icon.cdc37d2028b9bbdefd838f7bf7133ecd.svg";
export { ForwardRef as ReactComponent };